import React from 'react';
import './HealthToggle.css';

type HealthMode = 'headaches' | 'tensions' | 'lloros';

interface HealthToggleProps {
  mode?: HealthMode;
  onModeChange?: (mode: HealthMode) => void;
  healthMode?: HealthMode;
  onHealthModeChange?: (mode: HealthMode) => void;
  compact?: boolean;
  canUseLloros?: boolean;
}

const HealthToggle: React.FC<HealthToggleProps> = ({
  mode,
  onModeChange,
  healthMode,
  onHealthModeChange,
  compact = false,
  canUseLloros = false
}) => {
  const currentMode = mode || healthMode || 'headaches';
  const handleChange = onModeChange || onHealthModeChange || (() => {});

  // Determinar la posición del slider (solo para modo no compacto)
  const getSliderPosition = () => {
    if (currentMode === 'headaches') return 'slider-left';
    if (currentMode === 'tensions') return canUseLloros ? 'slider-center' : 'slider-right';
    if (currentMode === 'lloros') return 'slider-right';
    return 'slider-left';
  };

  return (
    <div className={`health-toggle-container ${compact ? 'health-toggle-container--compact' : ''}`}>
      <div className={`health-toggle ${compact ? 'health-toggle--compact' : ''} ${canUseLloros ? 'health-toggle--three-options' : ''}`}>
        <div
          className={`toggle-option ${currentMode === 'headaches' ? 'active' : ''}`}
          onClick={() => handleChange('headaches')}
        >
          <span className="toggle-icon">🤕</span>
          <span className="toggle-label">Dolores</span>
        </div>
        <div
          className={`toggle-option ${currentMode === 'tensions' ? 'active' : ''}`}
          onClick={() => handleChange('tensions')}
        >
          <span className="toggle-icon">🩺</span>
          <span className="toggle-label">Tensión</span>
        </div>
        {canUseLloros && (
          <div
            className={`toggle-option ${currentMode === 'lloros' ? 'active' : ''}`}
            onClick={() => handleChange('lloros')}
          >
            <span className="toggle-icon">😢</span>
            <span className="toggle-label">Lloros</span>
          </div>
        )}
        {!compact && (
          <div
            className={`toggle-slider ${getSliderPosition()}`}
            style={canUseLloros ? { width: 'calc(33.333% - 4px)' } : undefined}
          />
        )}
      </div>
    </div>
  );
};

export default HealthToggle;